import Vue from 'vue';

export default {
  // component name (used for Imports)
  name: 'event-has-varieties',

  // import data from parent
  inject: [
    'storageData',
    'addToCart',
    'eventsData',
    'removeFromCart',
    'user'
  ],

  props: {
    event: {}
  },

  data () {
    return {
      total: 0,
      isLoading: false,
      addToCartStatus: null,
      selectedVarieties: {
        driver: {
          selectableVarieties: [],
          eventHasVariety: null,
          amount: 1
        },
        accompanyingPerson: {
          selectableVarieties: [],
          eventHasVariety: null,
          amount: 0
        }
      }
    };
  },

  watch: {
    selectedVarieties: {
      handler: function (newValue) {
        this.calculateTotal();
      },
      deep: true
    }
  },

  methods: {
    getAvailableDropdownAmountForVariety: function (varietySelector, varietyKey) {
      if (varietyKey === 'driver') {
        if (varietySelector.eventHasVariety.maximumSelectableAmount > this.event.availableSeatAmount) {
          return this.event.availableSeatAmount;
        }
      }
      return varietySelector.eventHasVariety.maximumSelectableAmount;
    },
    calculateTotal: function () {
      let total = 0;
      total = total + (this.selectedVarieties.driver.amount * this.selectedVarieties.driver.eventHasVariety.price);
      if (this.selectedVarieties.accompanyingPerson.eventHasVariety) {
        total = total + (this.selectedVarieties.accompanyingPerson.amount * this.selectedVarieties.accompanyingPerson.eventHasVariety.price);
      }

      this.$eventBus.$emit('varietiesUpdated', {
        'event': this.event,
        'total': total,
        'action': 'add'
      });

      this.total = total;
    },
    addEventWithVarietiesToCart: function () {
      if (!this.isLoading) {
        this.isLoading = true;
        let proxy = this;
        this.addToCartPromise = this.addToCart(this.event, this.selectedVarieties);

        this.addToCartPromise.then(data => {
          proxy.addToCartStatus = data;

          let updatedEvent = Object.assign(this.event, {
            'availableSeatAmount': proxy.addToCartStatus.allAvailableSeats
          });

          if (proxy.addToCartStatus.status === 'error') {
            if (this.event.availableSeatAmount === 0) {
              // no more seats - remove from cart and mark as fully_booked
              this.removeFromCart(this.event.uuid);
              updatedEvent = Object.assign(updatedEvent, {
                'type': 'on_request'
              });
            } else {
              this.selectedVarieties.driver.amount = this.event.availableSeatAmount;
            }
          }

          Vue.set(this.eventsData.events, this.event.uuid, updatedEvent);
          proxy.isLoading = false;
        });
      }
    },
    getVarietyDataByUuid: function (selectableVarieties, varietyUuid) {
      let varietyMatch = null;
      selectableVarieties.forEach(function (selectableVariety) {
        if (selectableVariety.uuid === varietyUuid) {
          varietyMatch = selectableVariety;
        }
      });
      return varietyMatch;
    }
  },

  created () {
    this.$parent.$on('addEventWithVarietiesToCart', this.addEventWithVarietiesToCart);
    this.$on('updateVarietiesInCart', this.addEventWithVarietiesToCart);
  },

  mounted: function () {
    this.selectedVarieties.driver.selectableVarieties = this.event.eventHasVarieties;
    this.selectedVarieties.accompanyingPerson.selectableVarieties = this.event.eventHasAccompanyingPersonVarieties;
    if (this.storageData.cart[this.event.uuid]) {
      let storageSelectedVarieties = this.storageData.cart[this.event.uuid].selectedVarieties;
      if (storageSelectedVarieties.driver.eventHasVariety) {
        let storageVarietyUuid = storageSelectedVarieties.driver.eventHasVariety.uuid;
        let varietyData = this.getVarietyDataByUuid(this.event.eventHasVarieties, storageVarietyUuid);
        if (!varietyData) {
          varietyData = this.selectedVarieties.driver.selectableVarieties[0];
        }
        this.selectedVarieties.driver.eventHasVariety = varietyData;
        let amount = storageSelectedVarieties.driver.amount;

        if (amount > varietyData.maximumSelectableAmount) {
          amount = varietyData.maximumSelectableAmount;
        }

        this.selectedVarieties.driver.amount = amount;
      }
      if (storageSelectedVarieties.accompanyingPerson.eventHasVariety) {
        let storageVarietyUuid = storageSelectedVarieties.accompanyingPerson.eventHasVariety.uuid;
        let varietyData = this.getVarietyDataByUuid(this.event.eventHasAccompanyingPersonVarieties, storageVarietyUuid);
        if (!varietyData) {
          varietyData = this.selectedVarieties.accompanyingPerson.selectableVarieties[0];
        }
        this.selectedVarieties.accompanyingPerson.eventHasVariety = varietyData;
        let amount = storageSelectedVarieties.accompanyingPerson.amount;

        if (amount > varietyData.maximumSelectableAmount) {
          amount = varietyData.maximumSelectableAmount;
        }
        this.selectedVarieties.accompanyingPerson.amount = amount;
      }
    } else {
      this.selectedVarieties.driver.eventHasVariety = this.selectedVarieties.driver.selectableVarieties[0];
      if (this.selectedVarieties.accompanyingPerson.selectableVarieties.length > 0) {
        this.selectedVarieties.accompanyingPerson.eventHasVariety = this.selectedVarieties.accompanyingPerson.selectableVarieties[0];
      }
    }
  }

};



// WEBPACK FOOTER //
// ./src/apps/booking/components/events/eventHasVarieties/EventHasVarieties.js